module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfChc4AMP6lbBP.bfc5e221.woff2";